import React from 'react';
import { Layout } from 'antd';
import MemberSidebar from './components/member.sidebar.component';
import MemberFooter from './components/member.footer.component';
import { useTranslation } from 'react-i18next';

function SettingDashboard() {
    const { Content } = Layout;
    const { t } = useTranslation();
    return <>
        <MemberSidebar />
        <Layout className="site-layout">
            <Content style={{ margin: '0 16px' }}>
                <div className="site-layout-background">
                    <h1>{t('setting-dashboard.title')}</h1>
                </div>
            </Content>
            <MemberFooter />
        </Layout>
    </>;
}

export default SettingDashboard;